<template>
  <v-layout row>
    <v-flex>
      <v-select
        v-if="index > 0"
        v-model="operation"
        :items="operationOptions"
        @input="updateTerm" />

      <v-checkbox
        v-model="isNot"
        label="NOT"
        @change="updateTerm" />

      <v-select
        v-model="field"
        :items="fieldOptions"
        label="Field"
        @input="updateTerm" />

      <v-text-field
        v-model="value"
        label="Value"
        @input="updateTerm" />

      <v-btn
        @click.stop="deleteTerm"
      >
        Delete
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'SavedQueryRule',

  props: {
    index: {
      type: Number,
      default: 0
    },

    depth: {
      type: Number,
      default: 0
    },

    fieldOptions: {
      type: Array,
      default: () => ([])
    }
  },

  data () {
    return {
      operationOptions: [
        'OR',
        'AND'
      ],
      operation: '',
      isNot: false,
      field: '',
      value: ''
    }
  },

  computed: {
    query: {
      get () {
        const operation = this.index > 0
          ? `${this.operation} `
          : ''
        const isNot = this.isNot
          ? 'NOT '
          : ''
        const field = this.field
        const value = this.value
        return `${operation}${isNot}${field}="${value}"`
      }
    }
  },

  methods: {
    deleteTerm () {
      this.$emit('delete-term', this.index)
    },

    updateTerm () {
      this.$emit('update-term', this.index, this.query)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SavedQueryRule.vue